/* src/app/do-planning/remote-power-details/remote-power-details.component.css */
:host ::ng-deep .ui-dropdown {
  width: 100% !important;
}
:host ::ng-deep .ui-dropdown-panel {
  width: 567px;
}
.dropdown {
  width: 100% !important;
  margin-bottom: 12px;
}
.dropdown-select {
  width: 100% !important;
  height: 34px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
}
#remote-power-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 5px;
  cursor: default;
}
button {
  background-color: #a8a8a8 !important;
  color: white;
  border: none;
  width: 250px;
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  transition: 0.2s ease;
}
button:hover {
  background-color: #676767 !important;
}
.button:active {
  transform: scale(0.96);
}
.title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px !important;
}
.label {
  width: 392px;
}
p {
  margin-bottom: 0 !important;
}
:host ::ng-deep .nacogr {
  background-color: #e0e0e0 !important;
  font-family: "Roboto" !important;
}
:host ::ng-deep .ui-button.ui-widget.ui-state-default.ui-button-text-only.ui-state-active {
  background-color: #e0e0e0 !important;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 16px;
  margin: 4px 0;
  -webkit-user-select: none;
  user-select: none;
  height: 28px;
}
.inputcontainer {
  width: 100%;
  padding-left: 0;
  height: 35px;
}
.inputcontainer input {
  width: 100px;
  float: right;
}
.container input[type=checkbox] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 5px;
}
.container:hover input ~ .checkmark {
  background-color: #ccc;
}
.container input:checked ~ .checkmark {
  background-color: #ffffff;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.container input:checked ~ .checkmark:after {
  display: block;
}
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid #8e8e8e;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.consumption-value {
  width: 100px;
  right: 24px;
  height: 26px;
  margin: 0 12px;
}
.title-container {
  display: flex;
  justify-content: space-between;
}
:host ::ng-deep .grey-select-root .p-select-label {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
/*# sourceMappingURL=remote-power-details.component.css.map */
